import styled from "styled-components"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)`
  background-color: ${({ theme }) => theme.palette.primary.light};
  padding: 0;
  // padding-top: 2.5em;
  // padding-bottom: ${props => (props.bottom ? "2.5em" : "0")};
  // ${({ theme }) => theme.breakpoints.down("md")} {
  //   padding-top: 1em;
  //   padding-bottom: ${props => (props.bottom ? "1em" : "0")};
  // }
`
export const Image = styled(CustomImage)`
  width: 100%;
  height: 100%;
`
